import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BackendPaths } from '@common/backend-paths';
import { DataService } from '@data/data.service';
import { NotificationService } from '@notification/notification.service';
import { firstArray } from '@util/utils';

@Component({
  selector: 'app-team-delete-dialog',
  templateUrl: './team-delete-dialog.component.html'
})
export class TeamDeleteDialogComponent implements OnInit {

  teamName = '';

  constructor(
    public dialogRef: MatDialogRef<TeamDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private dataService: DataService,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    this.teamName = this.dialogData.teamName || '';
  }

  doNotDelete() {
    this.dialogRef.close();
  }

  doDelete() {
    const teamId = this.dialogData.teamId;
    const url = BackendPaths.TEAMS_FULL + teamId;
    const data = {
      op: 'deleteteam'
    };

    this.dataService.post(url, data).subscribe((result: any) => {
      const res = result?.result;
      if (res.success) {
        this.notificationService.showSuccess(
          res.msg || 'Team gelöscht'
        );
        this.dialogRef.close({
          id: teamId
        });
      } else {
        let errors: any[] = firstArray(res.errors, ['Fehler beim Löschen des Teams']);
        this.notificationService.showErrors(errors);
      }
    });
  }
}
